import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Bus"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.25 1.5H15.75C17.8211 1.5 19.5 3.17893 19.5 5.25V17.25C19.5 18.0784 18.8284 18.75 18 18.75V21H16.5V18.75H7.5V21H6V18.75C5.17157 18.75 4.5 18.0784 4.5 17.25V5.25C4.5 3.17893 6.17893 1.5 8.25 1.5ZM18 11.25V6H6V11.25H18ZM8.25008 3H15.7501C16.7013 3.00267 17.548 3.6032 17.8651 4.5H6.13508C6.45214 3.6032 7.29889 3.00267 8.25008 3ZM6 12.75V17.25H18V12.75H6ZM2.25 6H3.75V10.5H2.25V6ZM21.75 6H20.25V10.5H21.75V6ZM9 14.25V15.75H7.5V14.25H9ZM16.5 15.75V14.25H15V15.75H16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Bus.vue"]]);
